export function playAudio(url) {
  $("#jquery_jplayer_1").jPlayer({
    ready: function () {
      $(this).jPlayer("setMedia", {
        // title: "Bubble",
        mp3: url,
        oga: url,
        m4a: url
      });
    },
    swfPath: "/jplayer/dist/jplayer",
    supplied: "mp3,oga,m4a",
    wmode: "window",
    useStateClassSkin: true,
    autoBlur: false,
    smoothPlayBar: true,
    keyEnabled: true,
    remainingDuration: true,
    toggleDuration: true
  });
}

export function playVideo(url) {
  $("#jquery_jplayer_1").jPlayer({
    ready: function () {
      $(this).jPlayer("setMedia", {
        // title: "Big Buck Bunny",
        m4v: url,
        ogv: url,
        webmv: url,
        rtmpv: url,
        poster: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1542171891139&di=2f96c58db6ee4703826303181b5e5fd0&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F12%2F33%2F96%2F01m58PIC3Dz.jpg'
      });
    },
    swfPath: "/jplayer/dist/jplayer",
    supplied: "m4v,ogv,webmv,rtmpv",
    size: {
      width: '100%',
      height: "560px",
      cssClass: "jp-video-360p"
    },
    useStateClassSkin: true,
    autoBlur: false,
    smoothPlayBar: true,
    keyEnabled: true,
    remainingDuration: true,
    toggleDuration: true
  });

}



// WEBPACK FOOTER //
// ./src/helpers/jPlayer.js